/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import FocusTrap from 'focus-trap-react';
import * as Styled from './styles';

const Modal = ({
    children,
    dataTestId,
    width,
    height,
    padding,
    borderRadius,
    backgroundColor,
    labelledBy,
    onEsc
}) => (
    <FocusTrap
        focusTrapOptions={{
            onDeactivate: () => {
                if (onEsc) {
                    onEsc();
                }
            },
            fallbackFocus: `div`,
        }}
    >
        <Styled.Background data-test-id={dataTestId}>
            <Styled.ModalBackground
                width={width}
                height={height}
                padding={padding}
                borderRadius={borderRadius}
                backgroundColor={backgroundColor}
                role="dialog"
                aria-labelledby={labelledBy}
                tabIndex="-1"
            >
                {children}
            </Styled.ModalBackground>
        </Styled.Background>
    </FocusTrap>
);

Modal.defaultProps = {
    width: 400,
    height: 340,
    padding: 40,
    backgroundColor: 'white',
};

Modal.propTypes = {
    children: PropTypes.node.isRequired,
    dataTestId: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number || PropTypes.string,
    padding: PropTypes.number || PropTypes.string,
    borderRadius: PropTypes.number || PropTypes.string,
    backgroundColor: PropTypes.string,
    labelledBy: PropTypes.string,
    onEsc: PropTypes.func,
};

export default Modal;
